export default __webpack_public_path__ + "static/media/foodle-int02.a7faa1ec.gif";